import { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import Slider from 'modules/auth/components/Slider';
import { getLoginByCorporateId } from 'modules/auth/utils/getLoginByCorporateId';

import 'assets/styles/Pages.scss';
import 'assets/styles/Styles.scss';

import { useCustomAuth } from '../../contexts/CustomAuthContext';
import CustomLoginForm from '../../components/CustomLoginForm';
import { debugAuth } from '../../utils/debugAuth';

import LoginFooter from '../Login/LoginFooter';
import LoginHeader from '../Login/LoginHeader';
import LoginWarning from '../Login/LoginWarning';

type CustomLoginProps = {
  blockedMode?: boolean;
};

const CustomLogin: FC<CustomLoginProps> = ({ blockedMode }) => {
  const history = useHistory();
  const location = useLocation();
  const { isAuthenticated, user } = useCustomAuth();

  // Debug authentication configuration
  useEffect(() => {
    debugAuth.enable();
  }, []);

  const { pageStyle, warning } = getLoginByCorporateId();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated && user) {
      const returnUrl = new URLSearchParams(location.search).get('returnUrl');
      if (returnUrl) {
        history.push(returnUrl);
      } else {
        history.push('/');
      }
    }
  }, [isAuthenticated, user, history, location.search]);

  const handleLoginSuccess = () => {
    // The useEffect above will handle the redirect
  };

  const handleLoginError = (error: string) => {
    console.error('Login error:', error);
  };

  // Don't render the form if already authenticated
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className={`nk-split nk-split-page nk-split-md ${pageStyle}`}>
      <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
        <div className="nk-block nk-block-middle nk-auth-body">
          <LoginHeader blockedMode={blockedMode} />

          {/*
          {!blockedMode && (
            <div className="nk-block-head">
              <div className="nk-block-head-content">
                <h5 className="nk-block-title">{t('Sign In')}</h5>
                <div className="nk-block-des">
                  <p>{t('Welcome back! Please sign in to your account.')}</p>
                </div>
              </div>
            </div>
          )}
          */}
          {!blockedMode && (
            <CustomLoginForm
              onSuccess={handleLoginSuccess}
              onError={handleLoginError}
            />
          )}

          <LoginWarning warning={warning} />
        </div>

        <LoginFooter />
      </div>
      <Slider />
    </div>
  );
};

export default CustomLogin;
